import { useAuth } from 'contexts/auth'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { destinoInicial } from './destino-inicial'

const useRedirects = () => {
  const { user } = useAuth()
  const history = useHistory()

  useEffect(() => {
    history.push(destinoInicial(user))
  }, [user])
}

export default useRedirects
